import React from 'react';
import About from '../../about/About';
// import ToolBar from '../../toolbar/ToolBar';
import Contact from '../../contact/Contact';
import Mission from '../../mission/Mission';
import Stepper from '../../stepper/Stepper';
import Features from '../../features/Features';
import Marketing from '../../marketing/Marketing';
import TopFooter from '../../top-footer/TopFooter';
import Testimonial from '../../testimonial/Testimonial';
import BottomFooter from '../../bottom-footer/BottomFooter';
import DialogTrigger from '../dialog-trigger/DialogTrigger';
import PrivacyPolicy from '../../privacy-policy/PrivacyPolicy';
import FloatingActionButton from '../floating-action-btn/FloatingActionBtn';

// New Ecosystem Components
import EcosystemHero from '../../ecosystem/EcosystemHero';
import ProductsShowcase from '../../ecosystem/ProductsShowcase';
import PlatformValue from '../../ecosystem/PlatformValue';

// Removed PopupWithVideo to prevent blocking video popup on load



const SinglePager = ({ handleOpenModal,toggleTheme,theme,activeSection,handleNavClick }) => {
    return (
        <div className='singlepager-wrapper'>

            {/* PopupWithVideo removed as requested */}

            {/* <ToolBar /> */}


                        {/* Contains both the StickyNavbar & Hero component */}
                        <DialogTrigger toggleTheme={toggleTheme} theme={theme} activeSection={activeSection} handleNavClick={handleNavClick} />

            {/* New Ecosystem Hero - Modern landing with gradient background */}
            <EcosystemHero />

            {/* Products Showcase - Interactive cards showing all 4 products */}
            <ProductsShowcase />

            {/* Platform Value Proposition - Why choose ZoneZapp as platform */}
            <PlatformValue />

            {/* Removed: Old LandingMockup section - redundant with new EcosystemHero */}
            {/* Removed: Standalone Web App link - already in hero CTAs */}

            <About />
            <Features />
            <Marketing />
            <Mission />
            <PrivacyPolicy />
            <Stepper />
            <Testimonial />
            <Contact />
            <TopFooter />
            <BottomFooter />

            {/* Contains both the BackToTop & ChatAssistant component */}
            <FloatingActionButton />

        </div>
    );
}

export default SinglePager;